import { ATP_API_URL } from "../config/apiConfig";

export const uploadOnboardingDocumentAction = async ({
  entityId = "",
  id = 0,
  documentType,
  fileName,
  file,
}) => {
  try {
    const formData = new FormData();
    formData.append("Id", id);
    formData.append("EntityId", entityId);
    formData.append("DocumentType", documentType);
    formData.append("FileName", fileName || file?.name || documentType);
    formData.append("File", file);

    const response = await fetch(ATP_API_URL.UPLOAD_DOCUMENTS, {
      method: "POST",
      headers: {
        accept: "*/*",
        // Content-Type is intentionally omitted — browser sets it with boundary
      },
      body: formData,
    });

    if (response.ok) {
      let data = null;
      try {
        data = await response.json();
      } catch {
        /* no body */
      }
      console.log(`[UploadDoc] ✅ ${documentType} uploaded`, data);
      return { success: true, data };
    }

    const errorText = await response.text().catch(() => response.statusText);
    console.error(
      `[UploadDoc] ❌ ${documentType} failed (${response.status}):`,
      errorText,
    );
    return {
      success: false,
      error: errorText || `Upload failed (${response.status})`,
    };
  } catch (err) {
    console.error(
      `[UploadDoc] ❌ Network error for ${documentType}:`,
      err.message,
    );
    return {
      success: false,
      error: err.message || "Network error during upload",
    };
  }
};
